import { BadgeCheck, Timer, ClipboardCheck, SlidersHorizontal, MapPin, ShieldCheck } from "lucide-react";
import { ChapterTag, MaskedLines, FadeUp } from "./Reveal";
import { BookButton } from "./CTA";
import { SITE } from "../config/site";

const INSPECTOR_IMG = "https://images.pexels.com/photos/8293678/pexels-photo-8293678.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940";

const REASONS = [
  { icon: BadgeCheck, title: "25+ Years Experience", text: "A quarter-century of solving pest problems across NCR homes and businesses." },
  { icon: Timer, title: "Same-Day Inspection", text: "Fast response when you need it — same-day slots available across Delhi NCR." },
  { icon: ClipboardCheck, title: "Professional Assessment", text: "Every job begins with a proper inspection, not a guess and a spray can." },
  { icon: SlidersHorizontal, title: "Customized Treatment", text: "The treatment fits your pest, your property and your household — never one-size-fits-all." },
  { icon: MapPin, title: "Delhi NCR Coverage", text: "Local teams across Delhi, Gurugram and Noida who understand local pest patterns." },
  { icon: ShieldCheck, title: "100% Solution Guarantee*", text: "We stand behind the treatment we provide, per agreed guarantee terms." },
];

export const WhyUs = () => (
  <section id="why-us" data-testid="why-us-section" className="py-24 lg:py-32 bg-charcoal text-ivory grain relative overflow-hidden scroll-mt-20">
    <div className="max-w-7xl mx-auto px-5 lg:px-10 relative">
      <ChapterTag index="04" label="Why Us" dark />
      <div className="grid lg:grid-cols-12 gap-14 mt-10 items-start">
        <div className="lg:col-span-5">
          <h2 data-testid="why-us-headline" className="font-display font-semibold tracking-tight leading-[1.05] text-4xl sm:text-5xl lg:text-6xl">
            <MaskedLines lines={[<>Why choose</>, <span className="italic text-gold">{SITE.companyName}?</span>]} />
          </h2>
          <FadeUp delay={0.3} className="mt-10 relative">
            <div className="absolute -bottom-4 -left-4 w-full h-full border border-gold/40 pointer-events-none" aria-hidden="true" />
            <div className="relative overflow-hidden aspect-[4/3]">
              <img src={INSPECTOR_IMG} alt="Experienced pest-management professional conducting a detailed property inspection" data-testid="why-us-image" className="w-full h-full object-cover" loading="lazy" />
            </div>
          </FadeUp>
          <FadeUp delay={0.4} className="mt-10 flex items-end gap-5">
            <span data-testid="experience-stat" className="font-display text-[92px] lg:text-[120px] leading-[0.8] font-semibold text-gold">25+</span>
            <p className="text-sm text-ivory/70 leading-relaxed max-w-[200px] pb-2">
              Years of professional pest management experience across Delhi NCR.
            </p>
          </FadeUp>
        </div>
        <div className="lg:col-span-7 grid sm:grid-cols-2 gap-px bg-ivory/10 border border-ivory/10">
          {REASONS.map((r, i) => (
            <FadeUp key={r.title} delay={i * 0.07} className="bg-charcoal p-8 lg:p-9 hover:bg-wine-dark/60 transition-colors duration-500">
              <r.icon className="h-5 w-5 text-gold mb-5" strokeWidth={1.5} />
              <h3 className="font-display text-[22px] font-semibold mb-2">{r.title}</h3>
              <p className="text-sm text-ivory/60 leading-relaxed">{r.text}</p>
            </FadeUp>
          ))}
        </div>
      </div>
      <FadeUp delay={0.3} className="mt-14">
        <BookButton testid="why-us-book-btn" light />
      </FadeUp>
    </div>
  </section>
);
